export function isPinCodeNumber(value) {
  if (!value) return true;
  return new RegExp(/^(\s*\d{6}\s*)(,\s*\d{6}\s*)*,?\s*$/g).test(value);
}
